export default __webpack_public_path__ + "static/media/selenium-3.951bfd2d.svg";